import { createAction } from '@reduxjs/toolkit';

export const buttonUpdateRequest = createAction('emailsButton/updateRequest');
export const buttonUpdateError = createAction('emailsButton/updateError');
export const buttonUpdateStore = createAction('emailsButton/updateStore');

export const buttonStore = createAction('emailsButton/store');
export const buttonClear = createAction('emailsButton/clear');

export const buttonUpdateId = createAction('emailsButton/updateId');
export const buttonUpdateIsActive = createAction('emailsButton/updateIsActive');

export const buttonUpdateTextAlign = createAction('emailsButton/updateTextAlign');
export const buttonUpdateBackgroundColor = createAction('emailsButton/updateBackgroundColor');
export const buttonUpdateTextColor = createAction('emailsButton/updateTextColor');
export const buttonUpdateBorderRadius = createAction('emailsButton/updateBorderRadius');
export const buttonUpdateShape = createAction('emailsButton/updateShape');
export const buttonUpdateText = createAction('emailsButton/updateText');
export const buttonUpdateUrl = createAction('emailsButton/updateUrl');
